const $switcher = document.querySelector('[data-role=switcher]');
const $switcherContent = document.querySelectorAll('[data-role=switcher-content]');
const $switcherLabel = document.querySelectorAll('[data-role=switcher-label]');

$switcher?.addEventListener('click', () => {
	const currentType = $switcher?.getAttribute('data-type');

	$switcher.classList.toggle('_active');

	const otherLabel = Array.from($switcherLabel).find($el => $el.getAttribute('data-type') !== currentType);
	const newType = otherLabel?.getAttribute('data-type');

	if (!newType) return;

	$switcher.setAttribute('data-type', newType);

	$switcherContent.forEach($el => {
		$el.classList.toggle('_active', $el.getAttribute('data-type') === newType);
	});

	$switcherLabel.forEach($el => {
		$el.classList.toggle('_active', $el.getAttribute('data-type') === newType);
	});
});